import { useTranslation } from 'react-i18next'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import CurrencySelector from '@/common/components/CurrencySelector/CurrencySelector'
import { isEmptyValue } from '@/common/components/MatchTypeEditor/helpers'
import { getCurrencySymbolByCode } from '@/common/helpers/helpers'

import * as Styles from './styles'

const CurrencyInput = ({
  value,
  onChange,
  disabled,
  matchCurrency,
  onChangeMatchCurrency,
  currencies,
  storeCurrencyCode,
  selectableCurrency,
  hasError,
  inputBackgroundColor,
}) => {
  const { t } = useTranslation()

  const showError = hasError && isEmptyValue(value)
  const selectedCurrency = matchCurrency || storeCurrencyCode

  const handleChange = e => {
    const rawValue = e.target.value

    if (rawValue === '') {
      onChange(rawValue)
      return
    }

    const regex = /^\d*\.?\d{0,2}$/

    if (regex.test(rawValue)) {
      onChange(rawValue)
    }
  }

  const amountInput = (
    <InputWithLabel
      label={t('Valor')}
      value={value || ''}
      onChange={handleChange}
      fullWidth
      type="text"
      disabled={disabled}
      startAdornment={getCurrencySymbolByCode(selectedCurrency, currencies)}
      backgroundColor={inputBackgroundColor}
      error={showError}
      helperText={showError ? t('Este campo es obligatorio') : undefined}
    />
  )

  if (!selectableCurrency) return amountInput

  return (
    <Styles.Row>
      <CurrencySelector
        currencies={currencies}
        selectedCurrency={selectedCurrency}
        onChange={onChangeMatchCurrency}
        disabled={disabled}
        backgroundColor={inputBackgroundColor}
      />
      {amountInput}
    </Styles.Row>
  )
}

export default CurrencyInput
